import en from './en';
import nl from './nl';
import { Language, TranslationDictionary } from './types';

export type { Language, TranslationDictionary };

export const translations: Record<Language, TranslationDictionary> = {
  EN: en,
  NL: nl
};

